import { isNativeApp } from '../api/axios';
import { setAppMode } from '../offline/network';
import { clearCachedUser } from '../offline/session';
import { useAppMode } from '../offline/useOffline';
import { OFFLINE_SESSION_TOKEN } from '../offline/usersFile';

// التطبيق: زر اختيار الوضع (أونلاين / أوفلاين). الموقع: مؤشر حالة الاتصال فقط.
export default function ConnectionStatus() {
  const { mode, disconnected } = useAppMode();

  if (!isNativeApp()) {
    const title = disconnected ? 'لا يوجد اتصال بالخادم.' : 'متصل بالخادم.';
    return (
      <span
        title={title}
        aria-label={title}
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${
          disconnected ? 'border-amber-300 bg-amber-50 text-amber-800' : 'border-emerald-300 bg-emerald-50 text-emerald-700'
        }`}
      >
        <span className={`h-2 w-2 rounded-full ${disconnected ? 'bg-amber-500' : 'bg-emerald-500 animate-pulse'}`} />
        {disconnected ? 'غير متصل' : 'متصل'}
      </span>
    );
  }

  const switchTo = (next) => {
    if (next === mode) return;

    // الدخول من ملف المستخدمين بلا جلسة خادم: المزامنة تحتاج دخولًا حقيقيًا مع الاتصال.
    if (next === 'online' && localStorage.getItem('token') === OFFLINE_SESSION_TOKEN) {
      const ok = window.confirm('دخلت دون اتصال من ملف المستخدمين. للوضع أونلاين ومزامنة فحوصاتك سجّل الدخول مع الاتصال. فحوصاتك تبقى محفوظة على الجهاز. متابعة؟');
      if (!ok) return;
      localStorage.removeItem('token');
      clearCachedUser();
      setAppMode('online');
      window.location.href = '/login';
      return;
    }

    setAppMode(next);
  };

  const button = (value, label, activeClass) => (
    <button
      type="button"
      onClick={() => switchTo(value)}
      aria-pressed={mode === value}
      className={`rounded-full px-3 py-1 text-xs font-bold transition ${mode === value ? activeClass : 'text-slate-500'}`}
    >
      {label}
    </button>
  );

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 p-0.5"
        title={mode === 'offline'
          ? 'وضع أوفلاين: كل فحص جديد يُحفظ على الجهاز، ولا تُعرض فحوصات الخادم. للمزامنة اختر «أونلاين».'
          : 'وضع أونلاين: الفحوصات تُحفظ في الخادم مباشرة.'}
      >
        {button('online', 'أونلاين', 'bg-emerald-500 text-white shadow')}
        {button('offline', 'أوفلاين', 'bg-amber-500 text-white shadow')}
      </span>
      {mode === 'online' && disconnected && (
        <span className="text-xs font-semibold text-red-600" title="الوضع أونلاين لكن لا يوجد اتصال بالخادم.">⚠ لا يوجد اتصال</span>
      )}
    </span>
  );
}
